import OfflineTopBarNotification from './OfflineTopBarNotification';

export default OfflineTopBarNotification;